import { useEffect, useState } from "react";
const useCursor = function (listLength, downPress, upPress) {
    const [cursor, setCursor] = useState(0);
    useEffect(() => {
        if (listLength && downPress) {
            setCursor((prevState) => prevState !== listLength - 1 ? prevState + 1 : 0);
        }
        else if (listLength && upPress) {
            setCursor((prevState) => prevState !== 0 ? prevState - 1 : listLength - 1);
        }
    }, [downPress, upPress, listLength]);
    return cursor;
};
export default useCursor;
//# sourceMappingURL=useCursor.js.map